module.exports = __webpack_public_path__ + "static/logo_white-0a00190de3802f711cc52e324c7d0276.png";